module.exports = __webpack_public_path__ + "img/check.156551f6.svg";